import { render, staticRenderFns } from "./TaxAccounting.vue?vue&type=template&id=62840fc0&scoped=true&"
import script from "./TaxAccounting.vue?vue&type=script&lang=ts&"
export * from "./TaxAccounting.vue?vue&type=script&lang=ts&"
import style0 from "./TaxAccounting.vue?vue&type=style&index=0&id=62840fc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62840fc0",
  null
  
)

export default component.exports